import { render, staticRenderFns } from "./trigger_day.vue?vue&type=template&id=3c09fb24&scoped=true&"
import script from "./trigger_day.vue?vue&type=script&lang=js&"
export * from "./trigger_day.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c09fb24",
  null
  
)

export default component.exports